<template>
  <div class="content">
    <div class="pt20">
      <div class="back" @click="back(false)">
        <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
        <span>{{ $t('courseReviewDetail.back') }}</span>
      </div>
      <h4>{{ $t('courseReviewDetail.reviewDetail') }}</h4>
      <div class="scollView">
        <a-form :form="form" layout="vertical" autocomplete="off">
          <div class="title">{{ $t('courseReviewDetail.basicInfo') }}</div>
          <div class="list">
            <a-form-item class="full" :label="$t('courseReviewDetail.courseName')" :colon="false">
              <a-input v-decorator="['lessonName']"></a-input>
            </a-form-item>
            <a-form-item :label="$t('courseReviewDetail.courseResponsible')" :colon="false">
              <a-input v-decorator="['teacherName']"></a-input>
            </a-form-item>
          </div>
          <div class="list">
            <a-form-item :label="$t('courseReviewDetail.courseCategory')" :colon="false">
              <a-input v-decorator="['professionName']"></a-input>
            </a-form-item>
            <a-form-item :label="$t('courseReviewDetail.courseLanguage')" :colon="false">
              <a-input v-decorator="['lessonLanguage']"></a-input>
            </a-form-item>
          </div>
          <div class="list">
            <a-form-item :label="$t('courseReviewDetail.courseHours')" :colon="false">
              <a-input v-decorator="['lessonHours']"></a-input>
            </a-form-item>
            <a-form-item :label="$t('courseReviewDetail.courseCredits')" :colon="false">
              <a-input v-decorator="['lessonCredit']"></a-input>
            </a-form-item>
          </div>
          <div class="list">
            <a-form-item :label="$t('courseReviewDetail.courseIntro')" :colon="false">
              <a-textarea v-decorator="['lessonIntro']" :auto-size="{ minRows: 2, maxRows: 6 }" />
            </a-form-item>
            <a-form-item :label="$t('courseReviewDetail.courseObjective')" :colon="false">
              <a-textarea v-decorator="['lessonGoal']" :auto-size="{ minRows: 2, maxRows: 6 }" />
            </a-form-item>
          </div>
          <div class="list">
            <a-form-item :label="$t('courseReviewDetail.coursePlan')" :colon="false">
              <a-textarea v-decorator="['lessonPlan']" :auto-size="{ minRows: 2, maxRows: 6 }" />
            </a-form-item>
            <a-form-item :label="$t('courseReviewDetail.courseDifficulty')" :colon="false">
              <a-textarea v-decorator="['lessonDifficulty']" :auto-size="{ minRows: 2, maxRows: 6 }" />
            </a-form-item>
          </div>
          <div class="list">
            <a-form-item :label="$t('courseReviewDetail.courseTextbook')" :colon="false">
              <a-input v-decorator="['lessonMaterial']"></a-input>
            </a-form-item>
            <a-form-item :label="$t('courseReviewDetail.courseAttribute')" :colon="false">
              <a-input v-decorator="['lessonAttribute']"></a-input>
            </a-form-item>
          </div>
          <div class="list">
            <a-form-item :label="$t('courseReviewDetail.teachingTeamIntro')" :colon="false">
              <!-- <a-input v-decorator="['teachingTeam']"></a-input> -->
              <a-textarea v-decorator="['teachingTeamInfo']" :auto-size="{ minRows: 1, maxRows: 6 }" />
            </a-form-item>
            <a-form-item :label="$t('courseReviewDetail.courseCover')" :colon="false">
              <img :src="lessonCoverUrl" alt="" style="width: 350px; height: 200px" v-if="lessonCoverUrl" />
              <a-input :value="$t('courseReviewDetail.noCover')" v-else />
            </a-form-item>
          </div>
        </a-form>
      </div>
    </div>
    <div class="submit-button">
      <a-button type="primary" @click="visible = true">{{ $t('courseReviewDetail.review') }}</a-button>
    </div>
    <a-modal v-model="visible" :title="$t('courseReviewDetail.reviewDetail')" @ok="handleOk">
      <a-form :form="reviewForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }" autocomplete="off">
        <a-form-item :label="$t('courseReviewDetail.reviewResult')" :colon="false">
          <a-select
            v-decorator="[
              'reviewStatus',
              { rules: [{ required: true, message: $t('courseReviewDetail.selectReviewResult') }] }
            ]"
            :placeholder="$t('courseReviewDetail.selectReviewResult')"
            @change="handleReviewResult"
          >
            <a-select-option value="4">{{ $t('courseReviewDetail.pass') }}</a-select-option>
            <a-select-option value="3">{{ $t('courseReviewDetail.reject') }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-if="showRejectReason" :label="$t('courseReviewDetail.rejectReason')" :colon="false">
          <a-textarea
            v-decorator="[
              'reviewNotes',
              { rules: [{ required: true, message: $t('courseReviewDetail.inputRejectReason') }] }
            ]"
            :placeholder="$t('courseReviewDetail.inputRejectReason')"
            maxlength="200"
            :auto-size="{ minRows: 3, maxRows: 5 }"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { courseReviewDetail, courseReviewSave } from '@/api/admin'

export default {
  name: 'ToReviewer',
  data() {
    return {
      form: this.$form.createForm(this),
      reviewForm: this.$form.createForm(this),
      visible: false,
      showRejectReason: false,
      lessonCoverUrl: ''
    }
  },
  mounted() {
    courseReviewDetail({
      id: this.$route.query.id
    }).then(res => {
      if (res.code === 200) {
        this.form.setFieldsValue({
          ...res.data,
          name: res.data.courseName,
          teachingTeamInfo: res.data.teachingTeamInfo.join('； ')
        })
        this.lessonCoverUrl = res.data.lessonCover
      }
    })
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.reviewForm.resetFields()
        this.showRejectReason = false
      }
    }
  },
  methods: {
    back() {
      this.$router.push({
        name: 'courseReviewer'
      })
    },
    handleOk() {
      this.reviewForm.validateFields((err, values) => {
        if (!err) {
          const data = Object.assign(values, {
            id: this.$route.query.id
          })
          courseReviewSave(data).then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('courseReviewDetail.reviewSuccess'))
              this.visible = false
              this.$router.push({
                name: 'courseReviewer'
              })
            }
          })
        }
      })
    },
    handleReviewResult(value) {
      this.showRejectReason = value === '3'
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  position: relative;
  .scollView {
    overflow: auto;
    height: calc(100vh - 285px);
    padding-right: 10px;
  }
}
h4 {
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
}

.admin {
  width: 100%;
  cursor: pointer;
  text-align: right;
  margin-bottom: 21px;

  .user-logo {
    width: 26px;
    height: 26px;
    border-radius: 100%;
    margin-right: 12px;
  }

  .down {
    width: 10px;
    margin-left: 5px;
  }
}

/deep/ .ant-input-suffix {
  right: 12px;

  img {
    width: 23px;
    cursor: pointer;
  }
}

.back {
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6d6d6;

  img {
    height: 10px;
    margin-right: 9px;
  }
}

/deep/ .ant-form {
  .title {
    display: flex;
    font-size: 14px;
    font-weight: 600;
    color: #627587;
    line-height: 20px;
    position: relative;
    padding: 12px 17px;
    margin-bottom: 30px;
    align-items: center;
    border-bottom: 1px solid #ededed;

    &::before {
      left: 0;
      content: '';
      width: 4px;
      height: 12px;
      border-radius: 2px;
      position: absolute;
      background: #6b738c;
    }
  }

  .list {
    display: flex;

    .ant-form-item-label label {
      color: #000000;
    }

    .ant-form-item {
      width: 50%;
      padding-left: 45px;

      &:first-child {
        padding-left: 0;
        padding-right: 45px;
      }
    }

    .ant-input-affix-wrapper .ant-input-suffix {
      position: absolute;

      img {
        width: 23px;
        height: 23px;
      }
    }

    .ant-calendar-picker div {
      position: relative;

      .ant-calendar-picker-input {
        width: 228px;
        height: 35px;
        margin-right: 0;
        color: #000000;
        border-radius: 4px;
        background: #ffffff;
        border: 1px solid #d8dce0;
      }
    }

    .ant-input,
    .ant-select {
      border-radius: 4px;
      color: #000000;
    }

    .full .ant-input,
    .full .ant-select {
      width: 100%;
      height: 35px;
      color: #000000;
      margin-right: 0;
      border-radius: 4px;
    }

    .ant-input-wrapper.ant-input-group {
      .ant-input {
        border-right: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }

      .ant-input-group-addon {
        background: #fff;
        font-size: 14px;
        font-weight: 400;
        color: #5e7a92;
        line-height: 20px;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
  }
}
.submit-button {
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 40px;
  left: 0;
  margin: 0 auto;
}
/deep/ .anticon {
  color: #d5d5d5 !important;
}
</style>
